// extracted by mini-css-extract-plugin
module.exports = {"beatgrid":"styles-module__beatgrid___33iBc"};